/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';

import LoginLinkSection from './LoginLinkSection';
import messages from 'src/shared/app/authentication/l10n/loginLinkL10n';
import DocumentTitle from 'src/shared/app/base/component/document/DocumentTitle';

const LoginLinkMain = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <React.Fragment>
      <DocumentTitle>{intl.formatMessage(messages.heading)}</DocumentTitle>
      <LoginLinkSection />
    </React.Fragment>
  );
};

export default compose(React.memo)(LoginLinkMain);
